import styled, { css } from 'styled-components';
import { space } from 'styled-system';

const LogoStyles = styled.div`
  ${space}

  display: block;
  width: 2rem;
  height: 2rem;
  flex-shrink: 0;
  background-repeat: no-repeat;
  ${props => {
    const color = props.white ? props.theme.colors.white : props.theme.colors.primary;

    return css`
      background-image: url(${props.theme.logo(color.replace('#', '%23'))});
    `;
  }}
`;

export default LogoStyles;
